import { flushPromises as e, getUniqueString as t, hasSlotContent as n, returnFirstEl as r, warnIfUnmounted as i } from "../../common/utils/index.js";
import { t as a } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import o from "../../common/mixins/mode.js";
import { createTippy as s, getAnchor as c, getPopperOptions as l } from "../popover/tippy-utils.js";
import { TOOLTIP_DIRECTIONS as u, TOOLTIP_KIND_MODIFIERS as d, TOOLTIP_STICKY_VALUES as f } from "./tooltip-constants.js";
import { POPOVER_APPEND_TO_VALUES as p } from "../popover/popover-constants.js";
import { createCommentVNode as m, createElementBlock as h, createElementVNode as g, createTextVNode as _, mergeProps as v, normalizeClass as y, openBlock as b, renderSlot as x, toDisplayString as S, withKeys as C } from "vue";
//#region components/tooltip/tooltip.vue
var w = {
	compatConfig: { MODE: 3 },
	name: "DtTooltip",
	mixins: [o],
	props: {
		id: {
			type: String,
			default() {
				return t();
			}
		},
		fallbackPlacements: {
			type: Array,
			default: () => ["auto"]
		},
		inverted: {
			type: Boolean,
			default: !1
		},
		offset: {
			type: Array,
			default: () => [0, 12]
		},
		placement: {
			type: String,
			default: "top",
			validator(e) {
				return u.includes(e);
			}
		},
		sticky: {
			type: [Boolean, String],
			default: !0,
			validator: (e) => f.includes(e)
		},
		appendTo: {
			type: [HTMLElement, String],
			default: "body",
			validator: (e) => p.includes(e) || e instanceof HTMLElement
		},
		contentClass: {
			type: [
				String,
				Object,
				Array
			],
			default: ""
		},
		anchorClass: {
			type: [
				String,
				Object,
				Array
			],
			default: ""
		},
		message: {
			type: String,
			default: ""
		},
		enabled: {
			type: Boolean,
			default: !0
		},
		open: {
			type: [Boolean, null],
			default: null
		},
		transition: {
			type: Boolean,
			default: !0
		},
		delay: {
			type: Boolean,
			default: !0
		},
		theme: {
			type: String,
			default: null
		},
		externalAnchor: {
			type: String,
			default: null
		},
		externalAnchorElement: {
			type: HTMLElement,
			default: null
		}
	},
	emits: ["shown", "update:open"],
	data() {
		return {
			TOOLTIP_KIND_MODIFIERS: d,
			hasSlotContent: n,
			tip: null,
			inTimer: null,
			internalShow: !1,
			currentPlacement: this.placement
		};
	},
	computed: {
		tippyProps() {
			return {
				offset: this.offset,
				delay: this.delay ? 300 : !1,
				placement: this.placement,
				sticky: this.sticky,
				theme: this.inverted ? "inverted" : this.theme,
				animation: this.transition ? "fade" : !1,
				onShown: (e) => this.onShow(e, "onShown"),
				onShow: (e) => this.onShow(e, "onShow"),
				onHidden: this.onHide,
				popperOptions: l({
					fallbackPlacements: this.fallbackPlacements,
					hasHideModifierEnabled: !0,
					onChangePlacement: this.onChangePlacement
				})
			};
		},
		anchor() {
			return this.externalAnchorElement ? this.externalAnchorElement : this.externalAnchor ? document.body.querySelector(this.externalAnchor) : c(this.$refs.anchor);
		}
	},
	watch: {
		tippyProps: {
			handler: "setProps",
			deep: !0
		},
		open: {
			handler: function(e) {
				e !== null && this.enabled && (this.internalShow = e);
			},
			immediate: !0
		},
		internalShow(e) {
			!this.tip || !this.anchor || (e ? (this.setProps(), this.tip.show()) : this.tip.hide());
		},
		sticky(e) {
			this.tip.setProps({ sticky: e });
		}
	},
	async mounted() {
		!this.enabled && this.open != null && (console.warn("Tooltip: You cannot use both the enabled and open props at the same time."), console.warn("The open prop will be ignored.")), this.tip = s(this.anchor, this.initOptions()), (this.externalAnchor || this.externalAnchorElement) && (await e(), this.addExternalAnchorEventListeners()), i(r(this.$el), this.$options.name);
	},
	beforeUnmount() {
		(this.externalAnchor || this.externalAnchorElement) && this.removeExternalAnchorEventListeners(), this.anchor?._tippy && this.tip?.destroy();
	},
	methods: {
		getModeReferenceEl() {
			return this.anchor;
		},
		calculateAnchorZindex() {
			return r(this.$el).getRootNode().querySelector(".d-modal[aria-hidden=\"false\"], .d-modal--transparent[aria-hidden=\"false\"], .d-modal[open], .d-modal--transparent[open]") || r(this.$el).closest(".d-zi-drawer") ? 651 : 400;
		},
		hasVisibleFocus() {
			return this.anchor.matches(":focus-visible");
		},
		onEnterAnchor(e) {
			this.enabled && (this.delay && this.inTimer === null ? this.inTimer = setTimeout(() => {
				this.triggerShow(e);
			}, 300) : this.triggerShow(e));
		},
		triggerShow(e) {
			e.type === "focusin" ? this.open === null && this.hasVisibleFocus() && (this.internalShow = !0) : this.open === null && (this.internalShow = !0);
		},
		onLeaveAnchor(e) {
			e.type === "keydown" && e.code !== "Escape" || (clearTimeout(this.inTimer), this.inTimer = null, this.triggerHide());
		},
		triggerHide() {
			this.open === null && (this.internalShow = !1);
		},
		onChangePlacement(e) {
			this.currentPlacement = e;
		},
		onHide() {
			this.tip?.unmount(), this.$emit("shown", !1), this.open !== null && this.$emit("update:open", !1);
		},
		onShow(e, t) {
			if (!this.tooltipHasContent(e)) return !1;
			this.transition && t === "onShow" || (this.$emit("shown", !0), this.open !== null && this.$emit("update:open", !0));
		},
		setProps() {
			!this.tip || !this.tip.setProps || !this.anchor || this.tip && this.tip.setProps && this.tip.setProps({
				...this.tippyProps,
				appendTo: this.appendTo === "body" ? this.anchor?.getRootNode()?.querySelector("body") : this.appendTo,
				zIndex: this.calculateAnchorZindex()
			});
		},
		onMount() {
			this.setProps();
		},
		tooltipHasContent(e) {
			return e.props.content.textContent.trim().length !== 0;
		},
		initOptions() {
			return {
				content: this.$refs.content,
				arrow: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"7\"><path d=\"M 14.5,7 8,0 1.5,7 Z\"/></svg>",
				duration: 180,
				interactive: !1,
				trigger: "manual",
				hideOnClick: !1,
				touch: !1,
				onMount: this.onMount,
				showOnCreate: this.internalShow,
				popperOptions: l({ hasHideModifierEnabled: !0 })
			};
		},
		addExternalAnchorEventListeners() {
			["focusin", "mouseenter"].forEach((e) => {
				this.anchor?.addEventListener(e, (e) => this.onEnterAnchor(e));
			}), [
				"focusout",
				"mouseleave",
				"keydown"
			].forEach((e) => {
				this.anchor?.addEventListener(e, (e) => this.onLeaveAnchor(e));
			});
		},
		removeExternalAnchorEventListeners() {
			["focusin", "mouseenter"].forEach((e) => {
				this.anchor?.removeEventListener(e, (e) => this.onEnterAnchor(e));
			}), [
				"focusout",
				"mouseleave",
				"keydown"
			].forEach((e) => {
				this.anchor?.removeEventListener(e, (e) => this.onLeaveAnchor(e));
			});
		}
	}
}, T = { "data-qa": "dt-tooltip-container" }, E = ["id"];
function D(e, t, n, r, i, a) {
	return b(), h("div", T, [!n.externalAnchor && !n.externalAnchorElement ? (b(), h("span", {
		key: 0,
		ref: "anchor",
		class: y(n.anchorClass),
		"data-qa": "dt-tooltip-anchor",
		onFocusin: t[0] || (t[0] = (...e) => a.onEnterAnchor && a.onEnterAnchor(...e)),
		onFocusout: t[1] || (t[1] = (...e) => a.onLeaveAnchor && a.onLeaveAnchor(...e)),
		onMouseenter: t[2] || (t[2] = (...e) => a.onEnterAnchor && a.onEnterAnchor(...e)),
		onMouseleave: t[3] || (t[3] = (...e) => a.onLeaveAnchor && a.onLeaveAnchor(...e)),
		onKeydown: t[4] || (t[4] = C((...e) => a.onLeaveAnchor && a.onLeaveAnchor(...e), ["esc"]))
	}, [x(e.$slots, "anchor")], 34)) : m("", !0), g("div", v({
		id: n.id,
		ref: "content",
		"data-qa": "dt-tooltip",
		class: [
			"d-tooltip",
			{ [i.TOOLTIP_KIND_MODIFIERS.inverted]: n.inverted },
			n.contentClass
		]
	}, e.modeAttrs), [x(e.$slots, "default", {}, () => [_(S(n.message), 1)])], 16, E)]);
}
var O = /* @__PURE__ */ a(w, [["render", D]]);
//#endregion
export { O as default };

//# sourceMappingURL=tooltip.js.map